import diff from "../diff";
import serializeMoney from "./serializeMoney";
import serializeOrderedField from "./serializeOrderedField";
import serializeOrderTransfer from "./serializeOrderTransfer";

export default function serializeOrder(data, initialData, { includeSlotAttributes = false } = {}) {
  const company_id = (data.company && data.company.id) || data.company_id;
  const agent_id = (data.agent && data.agent.id) || data.agent_id;
  return {
    ...data,

    company_id: company_id,
    company: undefined,
    agent_id: agent_id === company_id ? null : agent_id,
    affiliate_id: (data.affiliate && data.affiliate.id) || data.affiliate_id,
    agent: undefined,
    product_id: (data.product && data.product.id) || data.product_id,
    product: undefined,
    notify_customer: data.notify_customer === "true" || data.notify_customer,
    notify_supplier: data.notify_supplier || undefined,
    assigned_creator_id: data.assigned_creator_id,
    product_variant_id: (data.product_variant && data.product_variant.id) || data.product_variant_id,
    product_variant: undefined,
    product_schedule_slot_id: !includeSlotAttributes
      ? data.product_schedule_slot === null
        ? null
        : (data.product_schedule_slot && data.product_schedule_slot.id) || undefined
      : undefined,
    product_schedule_slot: undefined,
    product_schedule_slot_attributes:
      includeSlotAttributes && data.product_schedule_slot
        ? {
            company_id: data.product_schedule_slot.company_id,
            product_id: data.product_schedule_slot.product_id,
            product_variant_id: data.product_schedule_slot.product_variant_id,
            starts_at: data.product_schedule_slot.starts_at,
            ends_at: data.product_schedule_slot.ends_at,
            includes_time: data.product_schedule_slot.includes_time,
            time_zone_name: data.product_schedule_slot.time_zone_name,
            active: data.product_schedule_slot.active,
            availability_type: data.product_schedule_slot.availability_type,
            total_stock_limit: data.product_schedule_slot.total_stock_limit,
            note: data.product_schedule_slot.note,
            stock_type: data.product_schedule_slot.stock_type,
            product_name: data.product_schedule_slot.product_name,
            product_variant_name: data.product_schedule_slot.product_variant_name,
          }
        : undefined,

    ...serializeMoney(data.agent_commision_amount, "agent_commision_amount", "agent_commision_amount_currency"),
    ...serializeMoney(data.saas_commision_amount, "saas_commision_amount", "saas_commision_amount_currency"),

    // NOTE we don't use the diff() here intenionally
    ordered_product_pricelist_items_attributes:
      data.ordered_product_pricelist_items &&
      data.ordered_product_pricelist_items.map((orderedItem) => ({
        id: orderedItem.id,
        product_pricelist_item_id: !orderedItem.id ? orderedItem.product_pricelist_item.id : undefined,
        quantity: orderedItem.quantity,
        persons_count: orderedItem.persons_count,
        // ordered_product_order_fields_attributes: orderedItem.ordered_product_order_fields && orderedItem.ordered_product_order_fields.map(serializeOrderedField),
      })),
    ordered_product_pricelist_items: undefined,

    // NOTE we don't use the diff() here intenionally
    ordered_product_order_fields_attributes:
      data.ordered_product_order_fields && data.ordered_product_order_fields.map(serializeOrderedField),
    ordered_product_order_fields: undefined,

    // NOTE we don't use the diff() here intenionally
    order_customer_participants_attributes:
      data.order_customer_participants &&
      diff(
        data.order_customer_participants.map((participant) => ({
          ...participant,
          ordered_product_pricelist_item_id:
            participant.ordered_product_pricelist_item && participant.ordered_product_pricelist_item.id,
          ordered_product_pricelist_item: undefined,
          ordered_product_order_fields_attributes:
            participant.ordered_product_order_fields &&
            participant.ordered_product_order_fields.map(serializeOrderedField),
          ordered_product_order_fields: undefined,
        })),
        initialData && initialData.order_customer_participants
      ),
    order_customer_participants: undefined,

    installments_attributes:
      data.installments &&
      diff(
        data.installments.map((installment) => ({
          ...installment,
          ...serializeMoney(installment.amount, "amount", "amount_currency"),
        })),
        initialData && initialData.installments
      ),
    installments: undefined,

    order_items_attributes:
      data.order_items &&
      diff(
        data.order_items.map((item) => ({
          ...item,
          ...serializeMoney(item.unit_price, "unit_price", "price_currency"),
        })),
        initialData && initialData.order_items
      ),
    order_items: undefined,

    order_transfers_attributes:
      data.order_transfers &&
      diff(data.order_transfers.map(serializeOrderTransfer), initialData && initialData.order_transfers),
    order_transfers: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeOrder.js